import React from "react";
import Typography from "@visa/vds/typography";
import FormControl from "@visa/vds/form-control";
import TextArea from "@visa/vds/textarea";

const OrderNotesPanel = (props) => {
  return (
    <>
      <Typography tag="h2">For Admin's Use</Typography>
      <Typography className="vss-field-label">
        <b>Notes from Order Detail:</b>
      </Typography>
      <FormControl position="left" space="fifty">
        <TextArea value={props.notes} readOnly={props.readOnly} />
      </FormControl>
    </>
  );
};
export default OrderNotesPanel;
